import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export function visitorId() {
  let v = localStorage.getItem("bb_vid");
  if (!v) {
    v = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("bb_vid", v);
  }
  return v;
}

export function PageTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    api.post("/track", { path: pathname, referrer: document.referrer || "", vid: visitorId() }).catch(() => {});
  }, [pathname]);
  return null;
}
